// Map assets & helpers for the MapLibre GL layer (OpenStreetMap tiles, no token).
// Isolated here so the cartographic layer can be replaced without touching app logic.

import { stateColor } from "@/lib/eventState";

// Free, token-less basemap: OpenStreetMap raster tiles.
export const OSM_STYLE = {
  version: 8,
  glyphs: "https://demotiles.maplibre.org/font/{fontstack}/{range}.pbf",
  sources: {
    osm: {
      type: "raster",
      tiles: [
        "https://a.tile.openstreetmap.org/{z}/{x}/{y}.png",
        "https://b.tile.openstreetmap.org/{z}/{x}/{y}.png",
        "https://c.tile.openstreetmap.org/{z}/{x}/{y}.png",
      ],
      tileSize: 256,
      attribution: "© OpenStreetMap contributors",
    },
  },
  layers: [{ id: "osm", type: "raster", source: "osm", minzoom: 0, maxzoom: 19 }],
};

// Unique marker-image name for a (state, categoryColor) pair.
export const iconName = (state, categoryColor) =>
  `pin_${state}_${(categoryColor || "none").replace("#", "")}`;

// Draw a teardrop pin: outer ring = state color, inner dot = category color.
export function makePinImage(state, categoryColor) {
  const dpr = 2;
  const w = 30;
  const h = 40;
  const canvas = document.createElement("canvas");
  canvas.width = w * dpr;
  canvas.height = h * dpr;
  const ctx = canvas.getContext("2d");
  ctx.scale(dpr, dpr);

  const cx = w / 2;
  const cy = 14;
  const r = 12;
  const outer = stateColor(state);

  // soft shadow
  ctx.shadowColor = "rgba(0,0,0,0.30)";
  ctx.shadowBlur = 4;
  ctx.shadowOffsetY = 2;

  // pointer
  ctx.beginPath();
  ctx.moveTo(cx - 7, cy + 6);
  ctx.lineTo(cx + 7, cy + 6);
  ctx.lineTo(cx, h - 2);
  ctx.closePath();
  ctx.fillStyle = outer;
  ctx.fill();

  // head circle
  ctx.beginPath();
  ctx.arc(cx, cy, r, 0, Math.PI * 2);
  ctx.fillStyle = outer;
  ctx.fill();
  ctx.shadowColor = "transparent";
  ctx.lineWidth = 2.5;
  ctx.strokeStyle = "#ffffff";
  ctx.stroke();

  // inner category dot
  ctx.beginPath();
  ctx.arc(cx, cy, 4.5, 0, Math.PI * 2);
  ctx.fillStyle = categoryColor || "#ffffff";
  ctx.fill();
  ctx.lineWidth = 1;
  ctx.strokeStyle = "rgba(255,255,255,0.9)";
  ctx.stroke();

  const data = ctx.getImageData(0, 0, canvas.width, canvas.height);
  return { image: data, pixelRatio: dpr };
}

// Build a clustering-ready GeoJSON FeatureCollection from map events.
export const toGeoJSON = (events) => ({
  type: "FeatureCollection",
  features: (events || []).map((e) => ({
    type: "Feature",
    geometry: { type: "Point", coordinates: [e.lng, e.lat] },
    properties: {
      id: e.id,
      state: e.state,
      icon: iconName(e.state, e.categoryColor),
    },
  })),
});
